import {
  Component,
  HostListener,
  Inject,
  inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ITravellerStory } from '../traveller-story-card/traveller-story-card.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-traveller-story-read-more',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './traveller-story-read-more.component.html',
  styleUrl: './traveller-story-read-more.component.scss',
})
export class TravellerStoryReadMoreComponent implements OnInit {
  public dialogRef = inject(MatDialogRef<TravellerStoryReadMoreComponent>);
  photos: string[] = [];
  mainImage: string | null = null;
  currentImageIndex: number = 0;
  currentStartIndex: number = 0;
  autoplayInterval: any;
  isMobileView: boolean = false;
  visibleThumbnails: number = 4;
  thumbnailWidth: number = 80;

  constructor(
    @Inject(MAT_DIALOG_DATA) public travellerStoriesData: ITravellerStory,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}
  ngOnInit(): void {
    this.photos = this.travellerStoriesData.photos || [];
    if (this.photos.length > 0) {
      this.mainImage = this.photos[0];
    }
    this.startAutoplay();
    this.updateViewPort();
  }

  ngOnDestroy(): void {
    this.stopAutoplay();
  }

  closeModal() {
    this.dialogRef.close();
  }
  // getStarsArray(star: number) {
  //   return Array.from({ length: star }, (_, index) => index);
  // }
  getStarsArray(rating: number): { filled: boolean }[] {
    return Array.from({ length: 5 }, (_, index) => ({
      filled: index < rating,
    }));
  }

  @HostListener('window:resize', [])
  onResize() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.updateViewPort();
  }

  updateViewPort() {
    if (!isPlatformBrowser(this.platformId)) return;
    const width = window.innerWidth;
    this.isMobileView = width <= 768;
    this.visibleThumbnails = this.isMobileView ? 3 : 4;
    this.adjustThumbnailScroll();
  }

  adjustThumbnailScroll() {
    if (this.currentImageIndex < this.currentStartIndex) {
      this.currentStartIndex = this.currentImageIndex;
    } else if (
      this.currentImageIndex >=
      this.currentStartIndex + this.visibleThumbnails
    ) {
      this.currentStartIndex =
        this.currentImageIndex - this.visibleThumbnails + 1;
    }
  }

  navigateMainImages(direction: number): void {
    const totalImages = this.photos.length;
    this.currentImageIndex =
      (this.currentImageIndex + direction + totalImages) % totalImages;
    this.mainImage = this.photos[this.currentImageIndex];
    this.adjustThumbnailScroll();
  }

  selectThumbnail(index: number): void {
    this.currentImageIndex = index;
    this.mainImage = this.photos[index];
    this.adjustThumbnailScroll();
  }

  updateMainImage() {
    this.mainImage = this.photos[this.currentImageIndex];
    this.updateThumbnailScroll();
  }

  isLeftDisabled(): boolean {
    return this.currentImageIndex === 0;
  }

  isRightDisabled(): boolean {
    return this.currentImageIndex === this.photos.length - 1;
  }

  updateThumbnailScroll() {
    if (this.photos.length > 4) {
      if (this.currentImageIndex < this.currentStartIndex) {
        this.currentStartIndex = this.currentImageIndex;
      } else if (this.currentImageIndex >= this.currentStartIndex + 4) {
        this.currentStartIndex = this.currentImageIndex - 3;
      }
    }
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      this.navigateMainImages(1);
    }, 2000);
  }

  stopAutoplay() {
    clearInterval(this.autoplayInterval);
  }
}
